module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon17.58b160eb.png";